import React from "react";
import { Box, Button, Typography } from "@mui/material";
import { Link as RouterLink, useLocation } from "react-router-dom";

const NotFoundPage: React.FC = () => {
  const location = useLocation();

  return (
    <Box sx={{ minHeight: "100vh", px: 3, py: 6 }}>
      <Typography variant="h4" fontWeight={800} gutterBottom>
        Page Not Found
      </Typography>
      <Typography variant="body1" color="text.secondary" gutterBottom>
        No route matched:
      </Typography>
      <Typography
        variant="body2"
        sx={{
          fontFamily: "monospace",
          color: "text.primary",
          mb: 3,
          wordBreak: "break-all",
        }}
      >
        {location.pathname}
        {location.search}
      </Typography>

      <Button
        component={RouterLink}
        to="/dashboard"
        variant="contained"
        color="primary"
      >
        Go to Dashboard
      </Button>
    </Box>
  );
};

export default NotFoundPage;
